import { getJiraInstances, getJiraProjects, getJiraFields } from '@/vuex/modules/integrations/jira/jira.utils';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Vue from 'vue';

const jira = {
    namespaced: true,
    state: {
        instances: [],
        projects: [],
        fields: {},
        error: null,
    },
    mutations: {
        setInstances (state, { instances }) {
            state.instances = instances;
        },
        setProjects: (state, { projects }) => {
            state.projects = projects;
        },
        setError: (state, { error }) => {
            state.error = error;
        },
        setFields (state, { projectId, issueTypeId, fields }) {
            if (!state.fields[projectId]) {
                Vue.set(state.fields, projectId, {});
            }

            Vue.set(state.fields[projectId], issueTypeId, fields);
        },
    },
    actions: {
        async loadInstances ({ commit, state }, { reFetch = false } = {}) {
            if (!isEmpty(state.instances) && !reFetch) {
                return;
            }

            try {
                commit('setError', { error: null });
                const { instances } = await getJiraInstances();

                commit('setInstances', { instances });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async loadProjects ({ commit, state, getters }, { reFetch = false, query } = {}) {
            if (!isEmpty(state.projects) && !reFetch && !query) {
                return state.projects;
            }

            try {
                commit('setError', { error: null });
                const { values: projects } = await getJiraProjects({
                    query,
                    ipaasSolutionInstanceId: getters.ipaasSolutionInstanceId,
                });

                if (!query) {
                    commit('setProjects', { projects });
                }

                return projects;
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async loadFields ({ commit, state, getters }, { projectId, issueTypeId, reFetch = false }) {
            if (!isEmpty(state.fields?.[projectId]?.[issueTypeId]) && !reFetch) {
                return;
            }

            try {
                commit('setError', { error: null });
                const fields = await getJiraFields({
                    projectId,
                    issueTypeId,
                    ipaasSolutionInstanceId: getters.ipaasSolutionInstanceId,
                });

                commit('setFields', { projectId, issueTypeId, fields });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
    },
    getters: {
        isJiraEnabled: (state) => {
            return get(state, 'instances[0].Enabled', false);
        },
        ipaasSolutionInstanceId: (state) => {
            return get(state, 'instances[0].IPaasSolutionInstanceId', '');
        },
    },
};

export default jira;
